import script from "./NotificationPermissionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationPermissionDialog.vue?vue&type=script&setup=true&lang=js"

import "./NotificationPermissionDialog.vue?vue&type=style&index=0&id=05b59162&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b59162"]])

export default __exports__